import { render } from "./Js.vue?vue&type=template&id=52263f4d&scoped=true"
import script from "./Js.vue?vue&type=script&lang=js"
export * from "./Js.vue?vue&type=script&lang=js"

import "./Js.vue?vue&type=style&index=0&id=52263f4d&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52263f4d"]])

export default __exports__